import React, { useState, useEffect } from "react";

import Footer from "../../components/shared/Footer";
import FileManager from "../upload/components/FileManager";
import DailyReportWidget from "../dashboards/components/DailyReportWidget";
import DailyUploadsWidget from "../dashboards/components/DailyUploadsWidget";
import DropInFiling from "./components/DropinFiling";
import { OrganizationService } from "../../services/ClientService";
import { authenticationService } from "../../services/authentication.service";
import { Globals } from "../../helpers/globals";

export default function UploadFile() {
    const currentUser = Globals.currentUserValue;
    const [isDrop, setIsDrop] = useState(false);

    useEffect(() => {
        OrganizationService.isFileDrop({
            id: currentUser.organizationID!,
        }).then((res) => {
            if (res.successful!) {
                setIsDrop(res.data!);
            }
        });
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Uploads</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Upload
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        File
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {currentUser.allowFileDrop &&
                currentUser.allowFileDrop === true ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <DropInFiling />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <FileManager />
                            </div>
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-xl-12">
                        <DailyUploadsWidget />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <DailyReportWidget />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
